import { AxDropdown } from "@axess/limestone";
import tippy, { Instance, Props } from 'tippy.js';
import { AxDatePicker, Cell, Mode } from "../../Components/AxDatepicker/AxDatepicker";
import { AxInit, ModuleName } from "../../Lib/AxSystem/AxInit";
import { AxLoad } from "../../Lib/AxSystem/AxLoad";
import { I18nHelper, Translations } from "../../Lib/Helper/I18nHelper";
import { AxCounter } from "../../Limestone/AxCounter/AxCounter";
import { AxLimeStone } from "../../Limestone/AxLimeStone";
import { QuantitySelection } from "./QuickSelection/QuantitySelection";

@ModuleName("TV4LandingQuickSelection")
export class LandingQuickSelection implements AxInit {
    init: initData;
    quantitySelectionInterface: QuantitySelection;

    public counter: QuickSelectionQuantityCounter[] = [];

    categoryDataAttributte: string = "category";
    categoryDropdown: AxDropdown = new AxDropdown();
    categoryMobileDropdown: AxDropdown = new AxDropdown();

    productCategoryDataAttributte: string = "product-category";
    productCategoryDropdown: AxDropdown = new AxDropdown();
    productCategoryMobileDropdown: AxDropdown = new AxDropdown();

    productDataAttributte: string = "product";
    productDropdown: AxDropdown = new AxDropdown();
    productMobileDropdown: AxDropdown = new AxDropdown();

    dateDataAttributte: string = "date";
    dateDropdown: AxDropdown = new AxDropdown();
    dateMobileDropdown: AxDropdown = new AxDropdown();

    quantityDataAttributte: string = "quantity";
    quantityDropdown: AxDropdown = new AxDropdown();
    quantityMobileDropdown: AxDropdown = new AxDropdown();

    currentSearchDate: moment.Moment;

    public datePicker: AxDatePicker;
    public datePickerMobile: AxDatePicker;
    public initComplete = false;
    private _mobileModalSelector = '#kt_modal_lg';

    constructor(private _i18nHelper = new I18nHelper(),
        private _AxLimestone = new AxLimeStone()) { }

    AxInit(init: initData): void {
        this.init = init;

        this.quantitySelectionInterface = new QuantitySelection();
        this.quantitySelectionInterface.init(this);

        $('[data-tv4-quickselection="submit"]').on('click', (e) => {
            e.preventDefault();
            let mode = $(e.delegateTarget).attr('data-target') as "desktop" | "mobile";
            this.addToCart(mode);
        });

        this.initModalContent();
        this.initDropdowns();
        this.initComplete = true;

        // Button event selection in modal. Simulates the ddl selection.
        $('#kt_modal_lg').on('click', '[data-button-type-dropdown]', (e: JQuery.ClickEvent<HTMLElement>) => {
            e.preventDefault();
            const dataAttrName = $(e.currentTarget).attr('data-button-type-dropdown');
            const selectedValue = $(e.currentTarget).attr('data-value');
            let dropdown: AxDropdown;
            switch (dataAttrName) {
                case this.categoryDataAttributte:
                    dropdown = this.categoryMobileDropdown;
                    break;
                case this.productCategoryDataAttributte:
                    dropdown = this.productCategoryMobileDropdown;
                    break;
                case this.productDataAttributte:
                    dropdown = this.productMobileDropdown;
                    break;
            }

            let $popper = this.getPopper(dropdown);
            if (!$popper) {
                return;
            }

            let dataValue = $($popper).find(`li[data-value="${selectedValue}"]`)?.attr('data-value');
            if (!dataValue) {
                return;
            }

            this.selectDropDownValue(dropdown, `.ax-dropdown__item[data-value="${dataValue}"]`);
        });
    }

    toggleVisibleSelector(selector: string, hide: boolean) {
        if (!selector) return;

        $(selector).toggleClass(selector.contains('mobile') ? 'd-none' : 'd-lg-none', hide);
        $(selector).toggleClass(selector.contains('mobile') ? 'd-block' : 'd-lg-block', !hide);
    }

    // Enable or disable a dropdown.
    // Toggle some clases to show "disabled" style (extra stuff for "mobile" ddls).
    // Reset dropdown selection if init is complete.
    setDDLSatus(dropdown: AxDropdown, enabled: boolean) {
        if (!dropdown) return;

        // True: When change selected value (selected by user interaction)
        // False: When is set from first page load (selected by code)
        if (this.initComplete) {
            dropdown.resetSelection();
        }

        dropdown.getElements().attr('disabled', enabled ? null : 'disabled');
        dropdown.getElements().find('a > div > i, a > div > span').toggleClass('text-dark', enabled);

        //If data-tv4-quickselection-mobile--dropdown exists is a mobile ddl, otherwise desktop.
        if (dropdown.getSelector().includes('mobile')) {
            dropdown.getElements().find('a > div:first').toggleClass('ax-bg-gray-100', !enabled);
            dropdown.getElements().find('a > div:first').toggleClass('border border-1', enabled);
        }
    }

    // Show/hide dropdown items based on the filter.
    filterDropDownValues(dropdown: AxDropdown, filter: string) {
        if (!dropdown) return;

        const $popper = this.getPopper(dropdown);
        if (!$popper) return;

        $popper.find('.ax-dropdown__item').removeClass('d-none')
        $popper.find('.ax-dropdown__item').not(filter).addClass('d-none');
    }

    // Select dropdown item based on the filter.
    selectDropDownValue(dropdown: AxDropdown, filter: string) {
        if (!dropdown) return;

        const $popper = this.getPopper(dropdown);
        if (!$popper) return;

        const $target = $popper.find(filter);
        dropdown.select($target);
    }

    // Add in modal #kt_modal_lg content for:
    // - Header: caption.
    // - Body: Needed divs for mobile quickselector:
    //      - data-mobile-drop-down: Container to show li elements as buttons (categories, product categories and products).
    //      - data-tv4-quickselection--overlay="quantity": Container to show person types and counters.
    //      - data-tv4-quickselection--overlay="date": Container to render datePickerMobile.
    // - Footer: Button to close modal.
    initModalContent() {
        const $modalHeader = $(this._mobileModalSelector)?.find('.modal-header');
        $modalHeader.prepend($('<span>').attr('data-modal-tittle', '').addClass('modal-title text-h5'));

        const $dataMobileDropDown = $('<div>').attr('data-mobile-drop-down', '').addClass('overflow-y d-none d-lg-none');
        const $quickSelectorQuantity = $('<div>').attr('data-tv4-quickselection--overlay', 'quantity').addClass('overflow-y d-none d-lg-none');
        const $quickSelectorDate = $('<div>').attr('data-tv4-quickselection--overlay', 'date').addClass('ax-mx-2-n ax-px-2 prod_selection__scrollable d-none d-lg-none')
            .append($('<div>').addClass('ax-pb-3 ax-mr-1')
                .append($('<div>').attr('data-tv4-quickselection--overlay', 'date-legend').addClass('ax-border-bottom ax-pb-1 ax-mx-2-n ax-px-2')))
            .append($('<div>').attr('data-message-closing-day-datepicker', ''))
            .append($('<div>').attr('data-tv4-quickselection--overlay', 'date-picker').addClass('ax-pt-0'));

        const $modalBody = $(this._mobileModalSelector)?.find('#kt_modal_lg_body');
        $modalBody.append($dataMobileDropDown);
        $modalBody.append($quickSelectorQuantity);
        $modalBody.append($quickSelectorDate);

        const $modalFooter = $(this._mobileModalSelector)?.find('#kt_modal_lg_footer');
        $modalFooter.append($('<button>').attr('type', 'button').attr('data-dismiss', 'modal').addClass('btn btn-secondary')
            .append(this._i18nHelper.GetTranslation(Translations.AdminClose)));
    }

    // Clean added content for modal(#kt_modal_lg).
    undoModalContent() {
        $(this._mobileModalSelector)?.find('.modal-header').find('[data-modal-tittle]').remove();
        $(this._mobileModalSelector)?.find('#kt_modal_lg_body').empty();
        $(this._mobileModalSelector)?.find('#kt_modal_lg_footer').empty();
    }

    // Only called from category, product category and product in mobile ddl.
    // Create a button for every visible li item.
    // Populate items into modal #kt_modal_lg > div[data-mobile-drop-down].
    fillDropDownContent(dropdown: AxDropdown) {
        const instance = dropdown[0]?._tippy as Instance<Props>;
        let $popper = $(instance?.popper);

        const $container = $(this._mobileModalSelector).find('[data-mobile-drop-down]');
        if ($popper && $container) {
            $container.empty();
            //create only buttons for visible li items
            $popper.find('li').not('.d-none').each((_, element) => {
                const $buttonContainer = $('<div>')
                    .addClass('ax-gap-2 d-flex flex-column ax-px-2 ax-py-1')
                    .append($('<button>')
                        .addClass('ax-btn ax-btn-secondary  text-center text-wrap')
                        .attr('data-button-type-dropdown', $(dropdown).attr('data-tv4-quickselection-mobile--dropdown'))
                        .attr('data-value', $(element).attr('data-value'))
                        .text($(element).text()));

                $container.append($buttonContainer);
            });
        }
        $popper.hide();
    }

    showModalFor(dataAttrName: string) {
        let caption = '';
        switch (dataAttrName) {
            case this.categoryDataAttributte:
                caption = this._i18nHelper.GetTranslation(Translations.Categories);
                break;
            case this.productCategoryDataAttributte:
                caption = this._i18nHelper.GetTranslation(Translations.AdminMegaMenuSubCategories);
                break;
            case this.productDataAttributte:
                caption = this._i18nHelper.GetTranslation(Translations.SelectTicket);
                break;
            case this.dateDataAttributte:
                caption = this._i18nHelper.GetTranslation(Translations.SelectDate);
                break;
            case this.quantityDataAttributte:
                caption = this._i18nHelper.GetTranslation(Translations.QuantityTicket);
                break;
            default:
                caption = this._i18nHelper.GetTranslation(Translations.Error);
                break;
        }

        const dropdownVisible = dataAttrName !== this.categoryDataAttributte && dataAttrName !== this.productCategoryDataAttributte && dataAttrName !== this.productDataAttributte;
        $(this._mobileModalSelector)?.find('[data-mobile-drop-down]').toggleClass('d-none', dropdownVisible);
        $(this._mobileModalSelector)?.find('[data-tv4-quickselection--overlay="date"]').toggleClass('d-none', dataAttrName !== this.dateDataAttributte);
        $(this._mobileModalSelector)?.find('[data-tv4-quickselection--overlay="quantity"]').toggleClass('d-none', dataAttrName !== this.quantityDataAttributte);
        $(this._mobileModalSelector)?.find('#kt_modal_lg_footer').toggleClass('d-none', dataAttrName !== this.quantityDataAttributte);

        $(this._mobileModalSelector)?.find('[data-modal-tittle]').text(caption);
        $(this._mobileModalSelector)?.modal('show');
    }

    getDropDown(mode: string, name: string): AxDropdown{
        if (name === this.categoryDataAttributte) {
            return mode === 'desktop' ? this.categoryDropdown : this.categoryMobileDropdown;
        } else if (name === this.productCategoryDataAttributte) {
            return mode === 'desktop' ? this.productCategoryDropdown : this.productCategoryMobileDropdown;
        } else if (name === this.productDataAttributte) {
            return mode === 'desktop' ? this.productDropdown : this.productMobileDropdown;
        } else if (name === this.dateDataAttributte) {
            return mode === 'desktop' ? this.dateDropdown : this.dateMobileDropdown;
        } else if (name === this.quantityDataAttributte) {
            return mode === 'desktop' ? this.quantityDropdown : this.quantityMobileDropdown;
        } else {
            return null;
        }
    }

    getDatePicker(mode: string): AxDatePicker {
        return mode === 'desktop'
            ? this.datePicker
            : this.datePickerMobile;
    }

    // Ddl category observer for desktop and mobile.
    // If selectedValue is not null:
    // 1) Set ProductCategory ddl enabled.
    // 2) Filter ProductCategory ddl items by data-value.
    // 3) Set disabled the descendants ddls.
    // 4) Check buy button availability.
    categorySelected(mode: string, selectedValue: string) {
        if (!selectedValue) {
            return;
        }

        this.setDDLSatus(this.getDropDown(mode, this.productCategoryDataAttributte), true);
        this.filterDropDownValues(this.getDropDown(mode, this.productCategoryDataAttributte), `[data-value^="${selectedValue}"]`);

        this.setDDLSatus(this.getDropDown(mode, this.productDataAttributte), false);
        this.setDDLSatus(this.getDropDown(mode, this.dateDataAttributte), false);
        this.setDDLSatus(this.getDropDown(mode, this.quantityDataAttributte), false);
        this.checkBuyButton(mode);
    }

    // Ddl product category observer for desktop and mobile.
    // If selectedValue is not null:
    // 1) Set Product ddl enabled.
    // 2) Filter Products ddl items by data-product-category-id.
    // 3) Set disabled the descendants ddls.
    // 4) Check buy button availability.
    productCategorySelected(mode: string, selectedValue: string) {
        if (!selectedValue) {
            return;
        }

        let productCategoryId = selectedValue?.split('|')[1] ?? null;

        this.setDDLSatus(this.getDropDown(mode, this.productDataAttributte), true);
        this.filterDropDownValues(this.getDropDown(mode, this.productDataAttributte), `[data-product-category-id="${productCategoryId}"]`);

        this.setDDLSatus(this.getDropDown(mode, this.dateDataAttributte), false);
        this.setDDLSatus(this.getDropDown(mode, this.quantityDataAttributte), false);
        this.checkBuyButton(mode);
    }

    // Ddl product observer for desktop and mobile.
    // If selectedValue is not null:
    // 1) Set enabled the descendants ddls.
    // 2) Reset counters.
    // 3) Init date Pickers for desktop and mobile.
    // 4) If is configured put default date in date ddls.
    // 5) Render 0 in quantity ddls.
    // 6) Check buy button availability.
    productSelected(mode: string, selectedValue: string) {
        if (!selectedValue) {
            return;
        }

        this.setDDLSatus(this.getDropDown(mode, this.dateDataAttributte), true);
        this.setDDLSatus(this.getDropDown(mode, this.quantityDataAttributte), true);
        this.resetCounters();

        this.initDatePicker(mode);
        this.setDateDefaultValue(mode);
        this.quantitySelectionInterface.renderQuantityLines(0, 0, mode);
        this.checkBuyButton(mode);
    }

    initDropdowns() {
        const onOpenDesktop = (dropdown) => ($parent) => {
            //auto close on scroll
            $(window).on('scroll', () => { dropdown.close($parent); });
            //auto close if ddl contains only one element
            const dataAttrName = $($parent).attr('data-tv4-quickselection-desktop--dropdown');
            if (dataAttrName === this.categoryDataAttributte || dataAttrName === this.productCategoryDataAttributte || dataAttrName === this.productDataAttributte) {
                let $popper = this.getPopper(dropdown);
                if ($popper) {
                    var elements = $($popper.find('.ax-dropdown__item'))?.length ?? 0;
                    if (elements == 1) {
                        dropdown.close($(window));
                    }
                }
            }
        }
        const desktopDropdownOptions = (dropdown) => ({ searchBar: true, onOpen: onOpenDesktop(dropdown) });

        // Configuration for Mobile ddl items (category, product category and product).
        // Create a button for each visible li item.
        // Populate items into modal #kt_modal_lg > div[data-mobile-drop-down].
        const convertItemsToButtons = ((dropdown: AxDropdown) => {
            const instance = dropdown[0]?._tippy as Instance<Props>;
            let $popper = $(instance?.popper);

            const $container = $(this._mobileModalSelector).find('[data-mobile-drop-down]');
            if ($popper && $container) {
                $container.empty();
                //create only buttons for visible li items
                $popper.find('li').not('.d-none').each((_, element) => {
                    const $buttonContainer = $('<div>')
                        .addClass('ax-gap-2 d-flex flex-column ax-px-2 ax-py-1')
                        .append($('<button>')
                            .addClass('ax-btn ax-btn-secondary  text-center text-wrap')
                            .attr('data-button-type-dropdown', $(dropdown).attr('data-tv4-quickselection-mobile--dropdown'))
                            .attr('data-value', $(element).attr('data-value'))
                            .text($(element).text()));

                    $container.append($buttonContainer);
                });
            }
            $popper.hide();
        });
        const dropdownOptionsMobile = (dropdown: AxDropdown) => ({
            searchBar: true,
            hideOnOutOfScreen: true,
            onOpen: (dropdown) => {
                const dataAttrName = $(dropdown).attr('data-tv4-quickselection-mobile--dropdown');
                if (dataAttrName === this.categoryDataAttributte || dataAttrName === this.productCategoryDataAttributte || dataAttrName === this.productDataAttributte) {
                    convertItemsToButtons(dropdown);
                }
                this.showModalFor(dataAttrName);
            },
            onSelect: (dropdown) => {
                const dataAttrName = $(dropdown).attr('data-tv4-quickselection-mobile--dropdown');
                if (dataAttrName != 'quantity') {
                    $(this._mobileModalSelector).modal('hide');
                }
            }
        });

        //Desktop initialization
        //Default values are managed automatically when 'selected' class is added in ul > li (valid for category, productCategory and product)
        this.categoryDropdown.init(`[data-tv4-quickselection-desktop--dropdown="${this.categoryDataAttributte}"]`, desktopDropdownOptions(this.categoryDropdown));
        this.productCategoryDropdown.init(`[data-tv4-quickselection-desktop--dropdown="${this.productCategoryDataAttributte}"]`, desktopDropdownOptions(this.productCategoryDropdown));
        this.productDropdown.init(`[data-tv4-quickselection-desktop--dropdown="${this.productDataAttributte}"]`, desktopDropdownOptions(this.productDropdown));
        this.dateDropdown.init(`[data-tv4-quickselection-desktop--dropdown="${this.dateDataAttributte}"]`, desktopDropdownOptions(this.dateDropdown));
        this.quantityDropdown.init(`[data-tv4-quickselection-desktop--dropdown="${this.quantityDataAttributte}"]`, desktopDropdownOptions(this.quantityDropdown));
        //suscriptions (order matters cascade ddls must be initialized first).
        this.categoryDropdown.getSelectObserver().subscribe((x: string) => this.categorySelected('desktop', x));
        this.productCategoryDropdown.getSelectObserver().subscribe((x: string) => this.productCategorySelected('desktop', x));
        this.productDropdown.getSelectObserver().subscribe((x: string) => this.productSelected('desktop', x));

        //Mobile initialization
        //Default values are managed automatically when 'selected' class is added in ul > li (valid for category, productCategory and product)
        this.categoryMobileDropdown.init(`[data-tv4-quickselection-mobile--dropdown="${this.categoryDataAttributte}"]`, dropdownOptionsMobile(this.categoryMobileDropdown));
        this.productCategoryMobileDropdown.init(`[data-tv4-quickselection-mobile--dropdown="${this.productCategoryDataAttributte}"]`, dropdownOptionsMobile(this.productCategoryMobileDropdown));
        this.productMobileDropdown.init(`[data-tv4-quickselection-mobile--dropdown="${this.productDataAttributte}"]`, dropdownOptionsMobile(this.productMobileDropdown));
        this.dateMobileDropdown.init(`[data-tv4-quickselection-mobile--dropdown="${this.dateDataAttributte}"]`, dropdownOptionsMobile(this.dateMobileDropdown));
        this.quantityMobileDropdown.init(`[data-tv4-quickselection-mobile--dropdown="${this.quantityDataAttributte}"]`, dropdownOptionsMobile(this.quantityMobileDropdown));
        //suscriptions (order matters cascade ddls must be initialized first).
        this.categoryMobileDropdown.getSelectObserver().subscribe((x: string) => this.categorySelected('mobile', x));
        this.productCategoryMobileDropdown.getSelectObserver().subscribe((x: string) => this.productCategorySelected('mobile', x));
        this.productMobileDropdown.getSelectObserver().subscribe((x: string) => this.productSelected('mobile', x));

        //Tooltips
        let tippyDefaultOptions = {
            placement: 'bottom',
            trigger: 'mouseenter click',
            interactive: false,
            offset: [0, 16],
            role: 'info',
            theme: 'dark',
            onShow(tooltipInstance) {
                if (!$(tooltipInstance.reference).parent().is('[disabled]')) {
                    return false;
                }
            }
        };
        //@ts-ignore
        tippy(`[data-tv4-quickselection-desktop--dropdown="${this.productCategoryDataAttributte}"] .ax-dropdown__trigger, [data-tv4-quickselection-mobile--dropdown="${this.productCategoryDataAttributte}"] .ax-dropdown__trigger`, {
            ...tippyDefaultOptions,
            content: this._i18nHelper.GetTranslation(Translations.QuickSelectorSelectCategoryFirst)
        });
        //@ts-ignore
        tippy(`[data-tv4-quickselection-desktop--dropdown="${this.productDataAttributte}"] .ax-dropdown__trigger, [data-tv4-quickselection-mobile--dropdown="${this.productDataAttributte}"] .ax-dropdown__trigger`, {
            ...tippyDefaultOptions,
            content: this._i18nHelper.GetTranslation(Translations.QuickSelectorSelectSubCategoryFirst)
        });
        //@ts-ignore
        tippy(`[data-tv4-quickselection-desktop--dropdown="${this.dateDataAttributte}"] .ax-dropdown__trigger, [data-tv4-quickselection-mobile--dropdown="${this.dateDataAttributte}"] .ax-dropdown__trigger`, {
            ...tippyDefaultOptions,
            content: this._i18nHelper.GetTranslation(Translations.SelectTicketFirst)
        });
        //@ts-ignore
        tippy(`[data-tv4-quickselection-desktop--dropdown="${this.quantityDataAttributte}"] .ax-dropdown__trigger, [data-tv4-quickselection-mobile--dropdown="${this.quantityDataAttributte}"] .ax-dropdown__trigger`, {
            ...tippyDefaultOptions,
            content: this._i18nHelper.GetTranslation(Translations.SelectDateFirst)
        });

        $('.clickable-card[data-url]').on('click', (e: JQuery.ClickEvent) => {
            if ($(e.target).closest('a, button').length > 0) return;
            const url = $(e.currentTarget).data('url');
            if (url) {
                window.location.href = url;
            }
        });
    }

    // Set in correct (depends on mode) AxDatePicker the default date if is configured.
    // If date is in closed days, look for the first available date.
    setDateDefaultValue(mode: string) {
        const target = this.getDatePicker(mode);

        if (target && this.init.setDefaultDate) {
            if (this.init?.closedDays || this.init?.closedDays?.length === 0) {
                target.setDate(moment());
            }
            else {
                let day = moment().format("YYYY-MM-DD");
                while (this.init?.closedDays?.some(x => x === day)) {
                    day = moment().add(1, 'days').format("YYYY-MM-DD");
                }
                target.setDate(moment(day, "YYYY-MM-DD"));
            }
        }
    }

    // Init DatePickers for desktop and mobile.
    // Check if selected product ddl item is not predateable and load the person types view.
    // Subscribe both DatePickers selection to setDate method.
    initDatePicker(mode: string) {
        const $selectedOption = this.getSelectedItem(mode, this.productDataAttributte);
        if ($selectedOption.length === 0) return;

        const preDateable = $selectedOption.attr('data-predateable') === 'true';
        this.toggleVisibleSelector(`[data-tv4-quickselection-${mode}--dropdown="date"]`, !preDateable);
        if (!preDateable) {
            this.quantitySelectionInterface.getQuantitySelection(moment(), mode);
        }

        const startDate = moment($selectedOption.attr('data-start'), 'YYYY-MM-DD');
        const blockedDates = this.init?.closedDays?.map(x => moment(x, "YYYY-MM-DD"));

        //Init date picker desktop
        const $popperDatePopper = this.getPopper(this.dateDropdown);
        const $datePicker = $popperDatePopper.find('[data-tv4-quickselection--dropdown="picker"]');
        $datePicker.html('');

        this.datePicker = new AxDatePicker();
        this.datePicker.Init({
            StartOfWeek: this.init.startOfWeek,
            Lang: this.init.lang,
            StartDate: startDate,
            DayRange: 0,
            Target: $datePicker[0],
            Mode: Mode.Inline,
            EndDate: null,
            monthsShown: 1,
            BlockedDates: blockedDates,
        });

        this.datePicker.ActivationSubject.subscribe((x: Cell) => {
            if (x != null) {
                this.setDate(x, 'desktop');
            }
        });
        //Init date picker mobile
        $(this._mobileModalSelector).find('[data-tv4-quickselection--overlay="date-picker"]').html('');
        $(this._mobileModalSelector).find('[data-tv4-quickselection--overlay="date-legend"]').html('');

        this.datePickerMobile = new AxDatePicker();
        this.datePickerMobile.Init({
            StartOfWeek: this.init.startOfWeek,
            Lang: this.init.lang,
            StartDate: startDate,
            DayRange: 0,
            Target: $(this._mobileModalSelector).find('[data-tv4-quickselection--overlay="date-picker"]')[0],
            Mode: Mode.Endless,
            LegendTarget: '[data-tv4-quickselection--overlay="date-legend"]',
            monthsShown: 2,
            scrollTargetQuerySelector: '[data-tv4-quickselection--overlay="date"]',
            BlockedDates: blockedDates,
        });
        this.datePickerMobile.ActivationSubject.subscribe((x: Cell) => {
            if (x != null) {
                this.setDate(x, 'mobile');
            }
        });
    }

    // Date observer for desktop and mobile.
    // Set, for the right date ddl, its value.
    // Reset counters and load person types view.
    // Check buy button availability.
    setDate(cell: Cell, mode: string) {
        if (cell != null) {
            const dateDropDown = this.getDropDown(mode, this.dateDataAttributte);
            dateDropDown.setValue(cell.Date.format(this.init.datePattern));
            dateDropDown.close();

            if (mode === 'mobile') {
                $(this._mobileModalSelector).modal('hide');
            }

            this.resetCounters();
            this.currentSearchDate = cell.Date;
            this.quantitySelectionInterface.getQuantitySelection(cell.Date, mode);
            this.checkBuyButton(mode);
        }
    }

    getPopper(dropdown: AxDropdown): JQuery<HTMLElement> {
        //@ts-ignore
        const instance = dropdown.getElements()[0]?._tippy as Instance<Props>;
        let $popper = $(instance?.popper);

        return $popper;
    }

    getSelectedItem(mode: string, name: string) {
        const dropDown = this.getDropDown(mode, name);

        if (!dropDown) {
            return null;
        }

        const $popper = this.getPopper(dropDown);
        if (!$popper) {
            return null;
        }

        return $($popper?.find('.ax-dropdown__item.selected'));
    }

    checkBuyButton(mode: string) {
        const categorySelected = this.getSelectedItem(mode, this.categoryDataAttributte);
        const productCategorySelected = this.getSelectedItem(mode, this.productCategoryDataAttributte);
        const productSelected = this.getSelectedItem(mode, this.productDataAttributte);

        const dateNeeded = $(productSelected)?.attr('data-predateable') === 'true'
            ? this.currentSearchDate != null
            : true;

        if (categorySelected != null && categorySelected.length > 0 &&
            productCategorySelected != null && productCategorySelected.length > 0 &&
            productSelected != null && productSelected.length > 0 &&
            dateNeeded &&
            this.counter.filter(x => x.mode === mode).some(x => x.counter.GetValue() > 0)
        ) {
            $(`button[data-target="${mode}"]`).removeAttr('disabled');
        } else {
            $(`button[data-target="${mode}"]`).attr('disabled', '');
        }
    }

    addToCart(mode: "desktop" | "mobile") {
        const productDropDown = this.getDropDown(mode, this.productDataAttributte);
        const tripleArr = (productDropDown.getValue() as string).split('-');
        const $popperProdPopper = this.getPopper(productDropDown);
        const $selectedOption = $($popperProdPopper?.find('.ax-dropdown__item.selected'));
        const requestURL = $selectedOption?.attr('data-add');
        let request;

        if (requestURL?.toLowerCase().includes('/package/')) {
            request = {
                projNr: tripleArr[0],
                packTariffSheetNo: tripleArr[1],
                packageNr: tripleArr[2],
                date: (this.currentSearchDate ?? moment()).format('YYYY-MM-DD'),
                packagePositions: []
            }
        } else {
            request = {
                projNr: tripleArr[0],
                poolNr: tripleArr[1],
                ticketTypeId: tripleArr[2],
                date: (this.currentSearchDate ?? moment()).format('YYYY-MM-DD'),
                personTypes: []
            }
        }

        for (let c of this.counter.filter(x => x.mode === mode)) {
            if (c.counter.GetValue() < 1) continue;

            const subTypeIdentifier = $(c.counter.getElement()).attr('data-subtypeidentifier');
            let toAdd;

            if (requestURL.toLowerCase().includes('/package/')) {
                toAdd = {
                    packPos: subTypeIdentifier,
                    quantity: c.counter.GetValue(),
                    linkedArticles: []
                }
            } else {
                toAdd = {
                    personTypeId: subTypeIdentifier,
                    quantity: c.counter.GetValue(),
                    linkedArticles: []
                }
            }

            let $parent;

            if (mode === "mobile") {
                $parent = $('[data-tv4-quickselection--overlay="quantity"]');
            } else {
                $parent = $(this.quantitySelectionInterface.quantitySelectionTippy.popper);
            }

            let count = 0;
            for (let article of $parent.find(`[data-tv4-quickselection--dropdown-quantity="article"][data-subtypeidentifier="${subTypeIdentifier}"],[data-tv4-quickselection--dropdown-quantity="article"][data-subtypeidentifier--copy="${subTypeIdentifier}"]`).not('.d-none')) {
                for (const checkbox of $(article).find('[data-tv4-quickselection-article]')) {
                    let $checkbox = $(checkbox);
                    const articleNr = $checkbox.attr('data-tv4-quickselection-article');
                    const checked = $checkbox.prop('checked');

                    toAdd.linkedArticles.push({
                        articleNr: articleNr,
                        checked: checked,
                        index: count
                    });
                }
                count++;
            }

            request.personTypes?.push(toAdd);
            request.packagePositions?.push(toAdd);
        }

        if ((request.personTypes?.length ?? 0) === 0 && (request.packagePositions?.length ?? 0) === 0) return;

        this._AxLimestone.LockButton($('[data-tv4-quickselection="submit"]')[0]);
        AxessViewer.loadPartialView(requestURL, request, (result) => {
            if (result?.success) {
                this.undoModalContent();
            }

            AxLoad.LoadModule('AxFireShoppingCartModal', {
                result: result,
                continueShoppingPath: '/Tickets',
                btn: '.tv4_prod-selection__addToCart-submit',
                ResetQuantity: false,
                queryAddition: '?ref=pi'
            });
            this._AxLimestone.UnlockButton($('[data-tv4-quickselection="submit"]')[0]);
        }, {
            silent: true,
            skipShoppingCartReload: false,
            addCulturInfo: false
        });
    }

    resetCounters() {
        for (let c of this.counter) {
            c.counter.resetValue();
        }
    }
}

interface initData {
    startOfWeek: number;
    datePattern: string;
    lang: string;
    setDefaultDate: boolean;
    closedDays: string[];
}
export class QuickSelectionQuantityCounter {
    counter: AxCounter;
    mode: "desktop" | "mobile";
}

